<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>多边形绘制</h2>
    </div>

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard
          title="高德地图多边形绘制"
          description="基于高德地图 JS API v2.0，支持开始/结束绘制、地图点击落顶点、多边形面实时渲染、顶点标记与中心点标记、球面面积与周长计算（自动在 m²/公顷/km² 间切换），以及 JSON / CSV / WKT 三种多边形数据格式的查看、复制与下载。"
          :codeContent="polygonDrawCode"
        >
          <PolygonDraw />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import PolygonDraw from '@/components/map/PolygonDraw.vue'

export default {
  name: 'PcMapPolygonDraw',
  components: {
    CodeCard,
    PolygonDraw
  },
  data() {
    return {
      polygonDrawCode: `<template>
  <div class="polygon-draw">
    <div ref="mapContainer" class="map-stage"></div>
    <el-button @click="drawing = !drawing">{{ drawing ? '结束绘制' : '开始绘制' }}</el-button>
    <el-input type="textarea" :rows="10" readonly :value="polygonDataText" />
    <el-button @click="copyPolygonData">复制数据</el-button>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  data() {
    return {
      AMap: null,
      map: null,
      layer: null,
      drawing: false,
      points: []
    }
  },
  computed: {
    // 多边形数据文本：绘制完成后展示并可复制
    polygonDataText() {
      return JSON.stringify({
        type: 'Polygon',
        coordinateSystem: 'GCJ02',
        pointCount: this.points.length,
        points: this.points.map((p, i) => ({ index: i + 1, lng: p.lng, lat: p.lat }))
      }, null, 2)
    }
  },
  async mounted() {
    const AMap = await AMapLoader.load({
      key: 'YOUR_AMAP_KEY',
      version: '2.0',
      plugins: ['AMap.Scale', 'AMap.ToolBar']
    })
    this.AMap = AMap
    this.map = new AMap.Map(this.$refs.mapContainer, {
      zoom: 13,
      center: [116.397428, 39.90923],
      doubleClickZoom: false
    })
    this.layer = new AMap.OverlayGroup()
    this.map.add(this.layer)
    this.map.on('click', this.handleMapClick)
    this.map.on('dblclick', () => { this.drawing = false })
  },
  methods: {
    // 绘制中：地图点击追加顶点，3 个顶点起闭合成面
    handleMapClick(event) {
      if (!this.drawing) return
      this.points.push({
        lng: Number(event.lnglat.getLng().toFixed(6)),
        lat: Number(event.lnglat.getLat().toFixed(6))
      })
      this.renderPolygon()
    },
    // 重新渲染多边形面 + 顶点标记
    renderPolygon() {
      this.layer.clearOverlays()
      const path = this.points.map(p => [p.lng, p.lat])
      if (path.length >= 3) {
        this.layer.addOverlay(new this.AMap.Polygon({
          path, fillColor: '#3478f6', fillOpacity: 0.25, strokeWeight: 3
        }))
      }
      path.forEach((position, index) => {
        this.layer.addOverlay(new this.AMap.Marker({ position }))
      })
    },
    // 复制多边形数据（clipboard + execCommand 双兜底）
    async copyPolygonData() {
      const text = this.polygonDataText
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
.skill-page {
  /* 覆盖全局 .skill-page：撑满内容区，内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
  background-color: transparent;
}

.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.page-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.page-header p {
  color: #606266;
  font-size: 14px;
}
</style>
